<template>
  <div id="app">
    <!-- <router-view /> -->

    <sideheader v-if="$route.meta.sider !== 'login'"></sideheader>
    <keep-alive>
      <sidebar v-if="$route.meta.sider === 'home'"></sidebar>
    </keep-alive>
    <keep-alive>
      <encodersidebar v-if="$route.meta.sider === 'encoder'"></encodersidebar>
    </keep-alive>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.path"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import sidebar from './components/sidebar.vue'
import sideheader from './components/sideheader.vue'

import encodersidebar from './components/encodersidebar.vue'
let __timerId = 0
export default {
  components: { sidebar, sideheader, encodersidebar },
  name: 'App',
  // mounted() {
  //     // console.log('mounted')
  //     if (this.land && this.land.LandId && this.hasLogin) {
  //         this.$store.dispatch('getEncoderInfo')
  //     }
  // },
  // created() {

  //     this.openTimer()
  // },
  // watch: {
  //     land: {
  //         handler(val) {
  //             console.log('watch land ', val, this.hasLogin)
  //             if (val !== null && this.hasLogin) {
  //                 this.$store.dispatch('getEncoderInfo')
  //             }
  //         }
  //     }
  // },
  // destroyed() {

  //   console.log("$route.meta==",$route.meta);
  //     this.closeTimer()
  // },
  // computed: {
  //     ...mapGetters(['hasLogin', 'land'])
  // },
  // methods: {
  //     // 打开全局定时器
  //     openTimer() {
  //         this.closeTimer()
  //         __timerId = setInterval(() => {
  //             this.$store.commit('setStateAttr', {
  //                 key: 'timerIdent',
  //                 val: !this.$store.state.timerIdent
  //             })
  //         }, 1000)
  //     },
  //     // 关闭定时器
  //     closeTimer() {
  //         if (__timerId !== 0) {
  //             clearInterval(__timerId)
  //             __timerId = 0
  //         }
  //     }
  // }
}

</script>
<style lang="less">
@import './scss/layer.scss';
@import './scss/base.scss';
@import './scss/button.scss';
@import './scss/color.scss';
@import './scss/layer.scss';
@import './scss/tag.scss';
@import './scss/highstandard.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
  font-family: pingfang;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
